import { useEffect } from "react"
import { DadosContainerDefault } from "../../components/Styles"
import GruposPermissoes from "../../components/GruposPermissoes"

function GruposPermissoesPage() {

  useEffect(() => {
    document.title = 'Grupos e Permissões | Gesttor'
  }, [])

  return (
    <DadosContainerDefault>
      <GruposPermissoes />
    </DadosContainerDefault>
  )
}

export default GruposPermissoesPage